import { DEFAULT_PIEVE_MODEL_ID, DEFAULT_PIEVE_REASONING_EFFORT } from '@shared/pieve/defaultModel.js';
import PIEVE_ONBOARDING_FINISHED_PREF_KEY from '@/lib/prefs/PIEVE_ONBOARDING_FINISHED_PREF_KEY.js';
import createThread from '@/redux/actions/pieveActions/createThread.js';
import sendPrompt from '@/redux/actions/pieveActions/sendPrompt.js';
import postOnboardingSummary from '@/redux/requests/onboarding/postOnboardingSummary.js';
import { setPref } from '@/redux/requests/prefsRequests.js';
import { generatePieveUserActivation } from '@/redux/requests/userActivationRequests.js';
import buildOnboardingLaunchPrompt from './buildOnboardingLaunchPrompt.js';
import mapOnboardingIntroChatMessagesForApi from './mapOnboardingIntroChatMessagesForApi.js';

/**
 * Finishes first-run setup the way the API expects: saves what the person told us to their job
 * knowledge, opens (or reuses) their one onboarding thread, sends the first message when the thread
 * is new, and marks setup finished. Resolves to { success, threadId } or { success: false, message }.
 */
const launchOnboardingThread = ({ introChat }) => {
  return async (dispatch) => {
    const { name, job, jobFamily, isDevRole } = introChat;
    const summaryRes = await postOnboardingSummary({ messages: mapOnboardingIntroChatMessagesForApi(introChat.messages), name, job, jobFamily: jobFamily || '', isDevRole });

    if (summaryRes?.success === false) {
      return { success: false, message: summaryRes.message || 'Your answers could not be saved.' };
    }

    const created = await dispatch(
      createThread({
        title: 'Getting started with Pieve',
        threadType: 'onboarding',
        composerModel: DEFAULT_PIEVE_MODEL_ID,
        composerReasoningEffort: DEFAULT_PIEVE_REASONING_EFFORT,
        pinned: true,
        hydrateAfterCreate: false,
        waitForHydrate: false
      })
    );
    const threadId = String(created?.id || created?.threadId || '').trim();

    if (!threadId) {
      return { success: false, message: created?.error?.message || 'Your first conversation could not be opened.' };
    }

    const prefRes = await setPref({ path: PIEVE_ONBOARDING_FINISHED_PREF_KEY, value: true });

    if (prefRes?.success === false) {
      return { success: false, message: prefRes.message || 'Setup could not be marked as finished.' };
    }

    if (created?.didCreateThread !== false || created?.hasEvents === false) {
      dispatch(sendPrompt({ threadId, prompt: buildOnboardingLaunchPrompt({ name, job }) }));
    }

    generatePieveUserActivation({ name, job, jobFamily: jobFamily || '', isDevRole });
    return { success: true, threadId };
  };
};

export default launchOnboardingThread;
